import { useQuery } from '@tanstack/react-query';
import { api, type ApiError, type BestSendTimeResult } from '@whinerp/client';
import { Panel, SectionLabel } from '@whinerp/ui';
import { useT } from '../../app/i18n.js';
import { useEntitlement } from '../../app/session.js';

/**
 * When this person usually engages with email (G-154), on the lead and the
 * contact, with how sure that is. The journey step "Wait for their best time"
 * reads the same answer.
 */
export function SendTimePanel({ objectKey, recordId }: { objectKey: 'lead' | 'contact'; recordId: string }): JSX.Element | null {
  const t = useT();
  const enabled = useEntitlement('F-069').enabled;
  const best = useQuery<BestSendTimeResult, ApiError>({
    queryKey: ['send-time', objectKey, recordId],
    queryFn: () => api.bestSendTime({ path: { objectKey, recordId } }),
    enabled,
  });
  if (!enabled || !best.data) return null;
  const view = best.data;
  const hour = view.hour === null ? null : `${String(view.hour).padStart(2, '0')}:00`;
  return (
    <Panel data-region="send-time">
      <div className="flex flex-col gap-1">
        <SectionLabel>{t('sendTime.title')}</SectionLabel>
        <p className="text-dense text-ink" data-send-time-basis={view.basis}>
          {hour === null
            ? t('sendTime.unknown')
            : view.basis === 'person'
              ? t('sendTime.person', { values: { hour, clicks: String(view.clicks), opens: String(view.opens) } })
              : t('sendTime.workspace', { values: { hour } })}
        </p>
      </div>
    </Panel>
  );
}
